// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6579":"d337308a","9755":"d337308a"}[chunkId] + ".chunk.css";
};